import i18next from 'i18next';

i18next.addResources('es_CL', 'OrderInfo', {
  orderId: 'Pedido número # {{id}}'
});
